module.exports = __webpack_public_path__ + "static/media/forest.d399c106.jpg";